module.exports = __webpack_public_path__ + "gonghua.a29110d2.png";